import { Download, Loader2 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { downloadBlob } from "@/lib/downloadBlob";
import {
	intelligenceApi,
	type FindingsListParams,
	type IntelligenceExportReport,
	type IntelligenceListParams,
} from "@/api/intelligence";
import { toast } from "sonner";

type Props = {
	report: IntelligenceExportReport;
	params: IntelligenceListParams | FindingsListParams;
	filename: string;
	disabled?: boolean;
	label?: string;
};

export function IntelligenceServerExportButton({
	report,
	params,
	filename,
	disabled,
	label = "Server CSV",
}: Props) {
	const [loading, setLoading] = useState(false);

	const handleExport = async () => {
		setLoading(true);
		try {
			const resp = await intelligenceApi.exportReport(report, params);
			downloadBlob(
				new Blob([resp.data], { type: "text/csv;charset=utf-8" }),
				filename.endsWith(".csv") ? filename : `${filename}.csv`
			);
			toast.success("CSV downloaded");
		} catch (e) {
			toast.error((e as Error)?.message ?? "Export failed");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Button
			type="button"
			variant="outline"
			size="sm"
			onClick={handleExport}
			disabled={disabled || loading}
			className="gap-2"
		>
			{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
			{label}
		</Button>
	);
}
